module.exports = __webpack_public_path__ + "img/checked-false.b93e7b29.svg";